import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pi0013',
    ecrans: ['00-2']
});
